/**
 * The header band (breadcrumb, title, subtitle) at the top of the Certification & Compliance page
 * (`src/pages/why-ryerson/ryerson-commitment/certification-compliance/index.tsx`, its only
 * importer). Copy is in `./CertificationAndComplianceHeaderContent.tsx`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import CertificationAndComplianceHeaderDesktop from "./CertificationAndComplianceHeaderDesktop";
import CertificationAndComplianceHeaderMobile from "./CertificationAndComplianceHeaderMobile";

/**
 * Renders the header band, mobile below `lg`. Its local name repeats the landing-page teaser's
 * (`../CertificateAndCompliance.tsx`); the page imports it as `CertificationAndComplianceHeader`.
 */
const CertificateAndCompliance: React.FC = () => {
	return (
		<>
			<Media lessThan="lg">
				<CertificationAndComplianceHeaderMobile />
			</Media>
			<Media greaterThanOrEqual="lg">
				<CertificationAndComplianceHeaderDesktop />
			</Media>
		</>
	);
};

export default CertificateAndCompliance;
